import { ClientsTreeApi, ClientsPageApi } from "@/api/consignor/index";

export default {
  //树查询
  async getClientsTree({ commit, state }, params) {
    //强制刷新
    if (params && params.force) {
      state.treeLoading = true;
      let res = await ClientsTreeApi();
      if (res.code == "0") {
        let data = res.data;
        commit("setTreeData", data);
      }
      state.treeLoading = false;
    } else {
      //如果有缓存了就不走接口
      if (state.treeData.length == 0) {
        state.treeLoading = true;
        let res = await ClientsTreeApi();
        if (res.code == "0") {
          let data = res.data;
          commit("setTreeData", data);
        }
        state.treeLoading = false;
      }
    }
  },

  //列表查询
  async getClientsPage({ commit, state }, params) {
    state.tableLoading = true;
    let res = await ClientsPageApi(params);
    if (res.code == "0") {
      var data = res.data.records;
      commit("setTableData", data);
      state.pageData.pageTotal = Number(res.data.total); //分页总数目
    }
    state.tableLoading = false;
  }
};
